import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CoreLink, Main } from '../../../components';
import { ROUTE_TYPE_SELF_HELP, USER_ROLES } from '../../../config/constants';
import Page from '../../../containers/Page';
import useClasses from '../../../hooks/useClasses';
import useRoutes from '../../../hooks/useRoutes';
import Form from './Form';
import FormHti from './FormHti';

import './style.scss';

const PageAccountChangeEmail = () => {
  const { t } = useTranslation();
  const { buildClass, joinClasses } = useClasses('PageAccountChangeEmail');
  const { account } = useRoutes(ROUTE_TYPE_SELF_HELP);

  const userHasRoleSsoClient = useSelector((state) => {
    const currentUserId = state.getIn(['login', 'uid'], null);
    const roles = state.getIn(['user', currentUserId, 'roles'], Immutable.List());
    return roles.includes(USER_ROLES.SSO_CLIENT);
  });

  return (
    <Page className={joinClasses(buildClass())} title={t('pages.account.change_email.title')}>
      <Main className="col-md-8 col-lg-6 offset-md-2 offset-lg-1 py-8 py-lg-12">
        <header className={buildClass('header')}>
          <CoreLink
            to={account.base}
            title={t('buttons.back')}
            className="icon-before icon-chevron icon-orientation-left"
          />
        </header>

        <h1 className={buildClass('title')}>{t('pages.account.change_email.title')}</h1>

        {userHasRoleSsoClient ? (
          <FormHti />
        ) : (
          <Form />
        )}
      </Main>
    </Page>
  );
};

export default PageAccountChangeEmail;
